import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import './SmartModemStatus.scss';

const getOptionalMessage = (message) => {
  if (message) {
    return (<div className="">{message}</div>);
  }
  return null;
};

const SmartModemStatus = (props) => {
  const { id, name, label, message } = props;
  return (
    <div>
      {getOptionalMessage(message)}
      <Field
        name={name}
        component={(lights) => {
          const hasError = lights.meta.touched && lights.meta.error;
          return (
            <div className={`${hasError ? 'switch-error ' : ''}modem-lights`}>
              <div className={`${hasError ? 'switch-error ' : ''}modem-lights-label`}>{label}</div>
              <div className="switch-field">
                <input
                  id={`${id}-off`}
                  type="radio" {...lights.input}
                  value="Off"
                  checked={lights.input.value === 'Off'}
                />
                <label htmlFor={`${id}-off`} id={`autotest-${id}-off`}>
                  <div className="modem-light-off" />
                  Off
                </label>

                <input
                  id={`${id}-red`}
                  type="radio"
                  {...lights.input}
                  value="Red"
                  checked={lights.input.value === 'Red'}
                />
                <label htmlFor={`${id}-red`} id={`autotest-${id}-red`}>
                  <div className="modem-light-red" />
                  Red
                </label>

                <input
                  id={`${id}-green`}
                  type="radio" {...lights.input}
                  value="Green"
                  checked={lights.input.value === 'Green'}
                />
                <label htmlFor={`${id}-green`} id={`autotest-${id}-green`}>
                  <div className="modem-light-green" />
                  Green
                </label>

                <input
                  id={`${id}-flashing-blue`}
                  type="radio" {...lights.input}
                  value="Flashing Blue"
                  checked={lights.input.value === 'Flashing Blue'}
                />
                <label htmlFor={`${id}-flashing-blue`} id={`autotest-${id}-flashing-blue`}>
                  <div className="modem-light-flashing-blue" />
                  Flashing Blue
                </label>

                <input
                  id={`${id}-blue`}
                  type="radio" {...lights.input}
                  value="Blue"
                  checked={lights.input.value === 'Blue'}
                />
                <label htmlFor={`${id}-blue`} id={`autotest-${id}-blue`}>
                  <div className="modem-light-blue" />
                  Blue
                </label>

              </div>
              {hasError &&
              <div className="switch-text-error">
                {lights.meta.error}
              </div>
              }
            </div>
          );
        }
        }
      />
    </div>
  );
};

SmartModemStatus.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  message: PropTypes.string
};

export default SmartModemStatus;



/** WEBPACK FOOTER **
 ** ./src/components/ContactUs/SmartModemStatus/SmartModemStatus.js
 **/